import { RUN_ANONYMIZATION_CHECK_STORAGE_KEY } from '../constants/organizationsKeys';
import { IPendingAnonymizationCheck } from '../types/organizations';

import { getRemainingAnonymizationPollMs } from './organizations';
import { parseJson, safeSessionStorage } from './safeStorage';

const isPendingAnonymizationCheck = (value: unknown): value is IPendingAnonymizationCheck => {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const { orgId, baselineTimestamp, startedAt } = value as Record<string, unknown>;

  return (
    typeof orgId === 'string' &&
    !!orgId &&
    typeof startedAt === 'string' &&
    getRemainingAnonymizationPollMs(startedAt, Date.now()) > 0 &&
    (baselineTimestamp === null || typeof baselineTimestamp === 'string')
  );
};

export const clearPendingAnonymizationCheck = () => safeSessionStorage.removeItem(RUN_ANONYMIZATION_CHECK_STORAGE_KEY);

export const savePendingAnonymizationCheck = (pending: IPendingAnonymizationCheck) =>
  safeSessionStorage.setItem(RUN_ANONYMIZATION_CHECK_STORAGE_KEY, JSON.stringify(pending));

export const readPendingAnonymizationCheck = (): IPendingAnonymizationCheck | null => {
  const raw = safeSessionStorage.getItem(RUN_ANONYMIZATION_CHECK_STORAGE_KEY);

  if (!raw) {
    return null;
  }

  const parsed = parseJson(raw);

  if (isPendingAnonymizationCheck(parsed)) {
    return parsed;
  }

  clearPendingAnonymizationCheck();
  return null;
};

export const readPendingAnonymizationCheckFor = (orgId: string): IPendingAnonymizationCheck | null => {
  const pending = readPendingAnonymizationCheck();

  return pending?.orgId === orgId ? pending : null;
};
